var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('dzTab',{attrs:{"active":_vm.activeTab,"tabs":_vm.tabs,"name":_vm.$options.name,"use-route":""},on:{"update:active":function($event){_vm.activeTab=$event}}}),_vm._t("notice",null,{"activeTab":_vm.activeTab}),_c('router-view')],2)}
var staticRenderFns = []

export { render, staticRenderFns }